"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatRouteLength = formatRouteLength;
exports.getSoilTypeName = getSoilTypeName;
exports.getEwcCodeName = getEwcCodeName;
exports.getCarType = getCarType;
exports.formatTransportDate = formatTransportDate;

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function formatRouteLength(transport) {
  var routeLength = transport.user_route_length / 1000;

  var tempVal = routeLength.toFixed(2).toString().replace(".", ",");

  // return routeLength.toFixed(2);
  return tempVal;
}

function getSoilTypeName(transport, soilTypes) {
  if (transport.soil.soil_type_string && transport.soil.soil_type_string !== "") {
    return transport.soil.soil_type_string;
  }
  var match = soilTypes.find(function (soilType) {
    return soilType.id === transport.soil.soil_type_id;
  });
  if (match) {
    return match.name;
  }
  return "";
}

function getEwcCodeName(transport, ewcCodes) {
  if (transport.soil.ewc_code_string && transport.soil.ewc_code_string !== "") {
    return transport.soil.ewc_code_string;
  }
  var matchEwc = ewcCodes.find(function (ewcCode) {
    return ewcCode.id === transport.soil.ewc_code_id;
  });
  if (matchEwc) {
    return matchEwc.code;
  }
  return "";
}

function getCarType(carType) {
  switch (carType) {
    case "2-axis":
      return "2-akselinen";
    case "3-axis":
      return "3-akselinen";
    case "4-axis":
      return "4-akselinen";
    case "5-axis":
      return "5-akselinen";
    case "semitrailer":
      return "Puoliperä";
  }

  return carType;
}

function formatTransportDate(timestamp) {
  return _moment2.default.utc(timestamp).local().format("DD.MM.YYYY"); // .format('DD.MM.YYYY HH:mm');
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/TransportDocumentUtil.js
 ** module id = 497
 ** module chunks = 0
 **/